/* eslint-disable */

import React, { useCallback, useEffect, useState } from 'react';
import AutorenewIcon from 'mdi-react/AutorenewIcon';
import WalletIcon from 'mdi-react/WalletIcon';
import { Card, CardBody, Col, Row } from 'reactstrap';
import axios from 'axios';
import LoadingIcon from 'mdi-react/LoadingIcon';
import { jwtDecode } from 'jwt-decode';
import CountRequestType from './CountRequestType';
import { getToken } from '../../../services/auth';
import { brMoneyMask } from '../../../shared/utils/utils';
import { useModal } from '../../../providers/ModalContext';

const request = {
  captcha: 0,
  cpf: 0,
  hired: 0,
  price: 0,
  profile: 0,
  reader: 0,
  serpro: 0,
  validation: 0,
  used: 0
};

const CountRequest = () => {
  const [data, setData] = useState(request);
  const [balance, setBalance] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [type, setType] = useState('');
  const { openModal } = useModal();

  const client = localStorage.getItem('client')
    ? JSON.parse(localStorage.getItem('client'))
    : '';

  const checkToken = () => {
    const decodedToken = jwtDecode(getToken());
    if (decodedToken.sub.chargeType) {
      setType(decodedToken.sub.chargeType);
    }
  };

  const fetchData = async () => {
    try {
      const { CancelToken } = axios;
      const source = CancelToken.source();
      setRefresh(true);
      const apiUrl = `${process.env.REACT_APP_WAS_KEY}/requestCount`;
      const res = await axios.get(apiUrl, {
        headers: { Authorization: `Bearer ${getToken()}` },
        cancelToken: source.token
      });
      setData(res.data);
      return () => {
        source.cancel();
      };
    } finally {
      setRefresh(false);
    }
  };

  const getBalance = useCallback(() => {
    const url = `${process.env.REACT_APP_WAS_KEY}/wallet/balance`;

    return axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'x-api-key': client.owner
        }
      })
      .then((res) => {
        setBalance(res.data.balance);
      });
  }, [client]);

  useEffect(() => {
    getBalance();
  }, [getBalance]);

  useEffect(() => {
    fetchData().catch((e) => {
      throw e;
    });
    checkToken();
  }, []);

  const goToRecharge = () => {
    openModal();
  };

  const refreshDashboard = () => {
    fetchData().catch((e) => {
      throw e;
    });
    getBalance().catch((e) => {
      throw e;
    });
  };

  const getPercent = (value, total) => (total ? +((value * 100) / total).toFixed() : 0);
  const availableRequests = Math.max((data.hired || 0) - (data.used || 0), 0);
  const requestCards = [
    {
      metricId: 'requests',
      title: 'Requisições disponíveis',
      value: availableRequests,
      percent: getPercent(availableRequests, data.hired || 0)
    },
    {
      metricId: 'reader',
      title: 'Notas lidas',
      value: data.reader || 0,
      percent: getPercent(data.reader || 0, data.used || 0)
    },
    {
      metricId: 'censored',
      title: 'Notas censuradas',
      value: data.serpro || 0,
      percent: getPercent(data.serpro || 0, data.used || 0)
    },
    {
      metricId: 'analyzed',
      title: 'Notas analisadas',
      value: data.validation || 0,
      percent: getPercent(data.validation || 0, data.used || 0)
    }
  ];

  return (
    <>
      {type === 'CREDIT' && (
        <Col xs={12} className="mb-3 mb-md-4">
          <Card className="count-request__balance-card w-100 d-flex flex-column">
            <CardBody className="dashboard__card-widget count-request__balance-card-body">
              {refresh && (
                <div className="panel__refresh">
                  <LoadingIcon />
                </div>
              )}
              <div className="count-request__balance">
                <div className="count-request__balance-label-row">
                  <span className="count-request__balance-eyebrow">Saldo da conta</span>
                  <button
                    type="button"
                    className="count-request__refresh-btn count-request__refresh-btn--inline"
                    aria-label="Atualizar saldo e estatísticas"
                    onClick={refreshDashboard}
                  >
                    <AutorenewIcon />
                  </button>
                </div>
                <div className="count-request__balance-main">
                  <div className="count-request__balance-figure">
                    <span className="count-request__balance-icon-wrap" aria-hidden="true">
                      <WalletIcon className="count-request__wallet-icon" />
                    </span>
                    <p className="count-request__balance-amount">
                      <span className="count-request__balance-currency">R$</span>
                      {brMoneyMask(balance)}
                    </p>
                  </div>
                  <p className="count-request__credit-helper">
                    Crédito para consultas e serviços contratados.
                  </p>
                  <button
                    type="button"
                    className="count-request__recharge-btn"
                    onClick={goToRecharge}
                  >
                    <span className="count-request__recharge-btn-inner">
                      <WalletIcon className="count-request__recharge-icon" />
                      Recarregar
                    </span>
                  </button>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      )}
      <Col xs={12}>
        <div className="count-request__metrics-wrap position-relative w-100">
          {refresh && (
            <div
              className="count-request__metrics-loading"
              aria-live="polite"
              aria-busy="true"
            >
              <LoadingIcon />
              <span className="sr-only">Atualizando estatísticas</span>
            </div>
          )}
          <Row className="align-items-start count-request__metrics-row">
            {requestCards.map(({ metricId, title, value, percent }) => (
              <Col key={metricId} xs={12} md={6} xl={3}>
                <CountRequestType
                  metricId={metricId}
                  title={title}
                  value={value}
                  percent={percent}
                />
              </Col>
            ))}
          </Row>
        </div>
      </Col>
    </>
  );
};

export default CountRequest;
